import React, { FC } from 'react';
import { ResetDefaultColumnsButtonProps } from './ResetDefaultColumnsButtonProps';
import { Button, Icon, Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import useTranslation from '../../hooks/useTranslation';

const ResetDefaultColumnsButton: FC<ResetDefaultColumnsButtonProps> = ({
  handleReset,
  style,
}) => {
  const t = useTranslation();
  return (
    <Tooltip title={t('tooltips.resetColumns')}>
      <Button style={style} onClick={handleReset}>
        <Icon sx={{ height: 'unset', width: 'unset', marginRight: '8px' }}>
          <RefreshIcon sx={{ fontSize: 'large' }} />
        </Icon>
        <span>{t('common.resetColumns')}</span>
      </Button>
    </Tooltip>
  );
};

export default ResetDefaultColumnsButton;
